<template>
  <q-card :flat="$q.screen.lt.md">
    <q-card-section class="q-pa-xs text-center" v-if="items && items.length>0">
      <q-avatar size="lg" dir="ltr" color="indigo" text-color="white" >
        <span class="text-subtitle2">{{ this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2))[this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2)).length - 1] }}</span>
      </q-avatar>
      <q-icon :name="this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2))[this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2)).length - 1] > this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2))[this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2)).length - 2]?'arrow_upward':'south'"
              :color="this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2))[this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2)).length - 1] > this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2))[this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2)).length - 2]?'green':'red'" size="lg">
        <q-tooltip>
          نسبت به ماه گذشته
        </q-tooltip>
      </q-icon>
      <q-space/>
      <q-chip clickable color="brown" text-color="white" square label="نرخ بازگشت مشتری"/>
    </q-card-section>
    <q-tooltip content-class="bg-transparent text-black">
      <q-card flat bordered>
        <q-card-section>
          <LineChart :items="items" :data="this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2))" title="نرخ بازگشت مشتری" />
        </q-card-section>
      </q-card>
    </q-tooltip>
  </q-card>
</template>

<script>
import LineChart from "@/components/OrderTrace/LineChart";
export default {
  name: "CustomerRetention",
  components: {LineChart},
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      dataRecords:[],
      orderChartOptions: {
        chart: {
          id: 'CustomerRetentionId',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'مقایسه مشتریان یکتا',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
      },
      orderChartSeries: [{
        name: 'مقدار',
        data: []
      }],
    }
  },
  created() {
    this.dataRecords=this.items.map(item => parseFloat(((item.CustomerCount - item.UniqCustomerCount)-item.NewCustomer) / (parseFloat(item.CustomerCount)) * 100).toFixed(2))
    this.orderChartSeries = [{
      data: this.items.map(item => item.UniqCustomerCount)
    }]
  }
}
</script>

<style scoped>

</style>